import { Dispatch, SetStateAction } from 'react';
import { NetworkType, RpcDetailType } from './types';
import LandingStakingCard from './LandingStakingCard';

interface Props {
    networkData: NetworkType[];
    setFlag: (x: boolean) => void;
    setNodeId: (x: string) => void;
    nodeID: string;
    networkType: 'dedicated' | 'staking';
}
const NodeCard = ({
  networkData,
  setFlag,
  setNodeId,
  nodeID,
  networkType,
}: Props) => (
    <>
        {networkData
            && networkData.length > 0
            && networkData.map((data, idx) => (
                <LandingStakingCard
                    key={`node-card${idx.toString()}`}
                    state={data.status}
                    nodeName={data.node_name}
                    endpoint={data.endpoint}
                    cloudId={data.cloud_id.toString()}
                    region={data.region_id.toString()}
                    networkId={data.network_id}
                    node={data.node_id}
                    redirection_url={data.redirection_url}
                    setFlag={setFlag}
                    setNodeId={setNodeId}
                    nodeID={nodeID}
                    createdAt={data.created_at}
                    networkType={networkType}
                />
            ))}
    </>
);
export default NodeCard;
